import React from 'react'

import { Menu, Footer } from '@niimko/drupal_menu'

import { HeaderComponent } from '@/components/Header';
import { SliderComponent } from './Slider';
import { NewsComponent } from '@/components/News';
import { BodyComponent } from './Body';
import { Stats } from './Stats';
import { Calltoaction } from '@/components/Calltoaction';
import { Message } from './Message'

import ThemeContext, { themes } from '@/theme/context'

export const MainPage = (props) => {
    return (<ThemeContext.Provider value={themes.default}>
        <HeaderComponent {...props} />
        <Menu {...props}/>
        {/* <Message {...props} /> */}
        <SliderComponent {...props}/>
        <Stats rows={3}/>
        <NewsComponent {...props}/>
        <BodyComponent {...props}/>
        <Calltoaction {...props}/>
        <Footer {...props}/>
    </ThemeContext.Provider>)
}